import PropTypes from "prop-types";
import cn from "classnames";
import scrollbarSize from "dom-helpers/scrollbarSize";
import React from "react";
import { connect } from "react-redux";
import dates from "react-big-calendar/lib/utils/dates";
// import Header from './Header'
import notify from "react-big-calendar/lib/utils/helpers";

const Header = ({ label }) => {
  return <span>{label}</span>;
};

class TimeGridHeaderDaily extends React.Component {
  handleHeaderClick = (date, view, e) => {
    e.preventDefault();
    notify(this.props.onDrillDown, [date, view]);
  };

  renderHeaderCells() {
    let { localizer, getDrilldownView, getNow, employees } = this.props;

    const today = getNow();

    return employees.map((emp, i) => {
      let drilldownView = false;
      // let label = localizer.format(date, 'dayFormat');
      let firstName = emp.EmployeeFirstName;
      let lastName = emp.EmployeeLastName;

      return (
        <div key={i} className={cn("rbc-header", "rbc-total-cell")}>
          <div>
            <span>{firstName}</span>
          </div>
          <div>
            <span>{lastName}</span>
          </div>
        </div>
      );
    });
  }

  render() {
    let {
      width,
      rtl,
      resources,
      range,
      events,
      getNow,
      accessors,
      selectable,
      components,
      getters,
      scrollRef,
      localizer,
      isOverflowing
    } = this.props;

    let style = {};
    if (isOverflowing) {
      style[rtl ? "marginLeft" : "marginRight"] = `${scrollbarSize()}px`;
    }

    const groupedEvents = [];

    return (
      <div
        style={style}
        ref={scrollRef}
        className={cn("rbc-time-header", isOverflowing && "rbc-overflowing")}
      >
        <div
          className="rbc-label rbc-time-header-gutter"
          style={{ width, minWidth: width, maxWidth: width }}
        />
        <div className="rbc-time-header-content">
          <div className={`rbc-row rbc-time-header-cell`}>
            {this.renderHeaderCells()}

            <div className={cn("rbc-header")}>
              <div>
                <span>Total</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.roster.events,
    displayWorkEvents: state.roster.displayAbsenceEvents,
    selectedEmployee: state.roster.selectedEmployee,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList,
    actionTypes: state.ActionTypesReducer.actionTypes
  };
}

export default connect(mapStateToProps)(TimeGridHeaderDaily);
